/* @flow */
import API from 'lib/RemindAPI';

export type Sort = 'name' | 'created' | 'last_active' | 'id';
export type SortDirection = 'desc' | 'asc';

export type OrganizationClassesFetchOptions = {
  sort?: Sort,
  page: number,
  query?: string,
  perPage: number,
  sortDirection?: SortDirection,
};

export function fetch(
  id: number | string,
  parameters: OrganizationClassesFetchOptions
): Promise<PartialGroup[]> {
  const options = {
    sort_type: parameters.sort,
    per_page: parameters.perPage,
    sort_direction: parameters.sortDirection,
    page: parameters.page,
    q: parameters.query,
  };

  return API.request(`/organizations/${id}/classes`, 'GET', options).then(
    response => response.classes
  );
}
